import React from 'react';

import SpinnerImage from '../../assets/images/Spinner.svg';

const Spinner = () => {
  return <img src={SpinnerImage} alt="Loading..." />;
};

export default Spinner;
